export enum Privacy {
  Private = 'private',
  Public = 'public',
}
